// Estilos compartilhados entre a ficha cadastral, sócios e documentos (mesmo visual de Secretarias)

export const cardSx = {
    backgroundColor: "#fff",
    border: "1px solid #e5e7eb",
    borderRadius: "12px",
    boxShadow: "0 1px 3px rgba(0,0,0,0.05)",
    p: { xs: 2, md: 3 },
};

export const labelSx = { display: "block", mb: 0.75, fontSize: 12, fontWeight: 600, color: "#374151" };

export const inputSx = {
    "& .MuiOutlinedInput-root": {
        borderRadius: "8px",
        fontSize: 14,
        backgroundColor: "#fff",
        "&.Mui-focused fieldset": { borderColor: "#0b243d" },
    },
    "& .MuiFormHelperText-root": { mx: 0, fontSize: 12 },
};

export const botaoPrincipalSx = {
    textTransform: "none", fontSize: 13, fontWeight: 700, color: "#111827", backgroundColor: "#ffc845",
    borderRadius: "8px", boxShadow: "none", px: 2, "&:hover": { backgroundColor: "#f5b82e", boxShadow: "none" },
};

export const botaoSecundarioSx = {
    textTransform: "none", fontSize: 13, fontWeight: 600, color: "#374151", backgroundColor: "#fff",
    border: "1px solid #e5e7eb", borderRadius: "8px", px: 2, "&:hover": { backgroundColor: "#f3f4f6" },
};

export const tituloSecaoSx = { fontSize: 16, fontWeight: 700, color: "#111827" };
export const subtituloSecaoSx = { fontSize: 12, color: "#6b7280" };

export const iconeSecaoSx = {
    width: 36, height: 36, borderRadius: "8px", backgroundColor: "#f3f4f6", color: "#374151",
    display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0, "& svg": { fontSize: 20 },
};

// Grade de campos: 1 coluna no celular, `colunas` a partir de md
export const gradeSx = (colunas = 2) => ({
    display: "grid",
    gridTemplateColumns: { xs: "1fr", md: `repeat(${colunas}, minmax(0, 1fr))` },
    gap: 2,
});

export const STATUS_DOCUMENTO_CHIP = {
    "Válido": { label: "Aprovado", cor: "#15803d", fundo: "#dcfce7" },
    "Em Análise": { label: "Em análise", cor: "#b45309", fundo: "#fef3c7" },
    "Rejeitado": { label: "Rejeitado", cor: "#b91c1c", fundo: "#fee2e2" },
    "Pendente": { label: "Pendente", cor: "#4b5563", fundo: "#f3f4f6" },
};
